<div *ngIf="activeFlightSegment" class="flight-card-wrap">
    <div class="flight-card-title">
        <h4>{{ pageConstants[title] }}</h4>
    </div>
    <div class="flight-card-content-wrap">
        <ua-flight-card [hideMoreInformation]="hideMoreInformation" [flightDetails]="activeFlightSegment" [isExpanded]="showMoreInformation" (moreInfo)="toggleMoreInfo()"></ua-flight-card>
        <ng-container *ngIf="showMoreInformation">
            <ng-container *ngFor="let segment of flightDetails?.segments">
                <div class="seperator"></div>
                <ua-flight-card *ngIf="segment.activeFlightSegment !== true" [flightDetails]="segment"></ua-flight-card>
            </ng-container>
        </ng-container>
    </div>
</div>
